import { Step, StepMap } from 'prosemirror-transform';
import { Schema } from 'prosemirror-model';
export default class TrackedStep {
  step;
  invertedStep;
  maps;

  constructor(step, invertedStep, maps) {
    this.step = step;
    this.invertedStep = invertedStep;
    this.maps = maps;
  }

  toJSON() {
    const mapsJSON = this.maps.map(stepMap => {
      // @ts-ignore
      return { ranges: stepMap.ranges };
    });

    const obj = {
      step: this.step.toJSON(),
      invertedStep: this.invertedStep.toJSON(),
      maps: mapsJSON
    };

    return obj;
  }

  static fromJSON(obj, schema) {
    return new TrackedStep(
      Step.fromJSON(schema, obj.step),
      Step.fromJSON(schema, obj.invertedStep),
      obj.maps.map((stepMapJSON) => new StepMap(stepMapJSON.ranges))
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/client/editor-core/TrackedStep.js